"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPendo = void 0;
var tslib_1 = require("tslib");
var createPendo = function (config) {
    return {
        name: 'pendo-plugin',
        config: {
            token: config.token,
            // Setting the stage because it will be used when sending userId as recommended by pendo.
            // https://support.pendo.io/hc/en-us/articles/360031862352
            stage: config.stage
        },
        initialize: function (_a) {
            var config = _a.config;
            // https://support.pendo.io/hc/en-us/articles/360046272771-Developer-s-Guide-To-Installing-the-Pendo-Snippet#overview-0-0
            // @ts-ignore
            (function (apiKey) {
                (function (p, e, n, d, o) {
                    var v, w, x, y, z;
                    o = p[d] = p[d] || {};
                    o._q = o._q || [];
                    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
                    for (w = 0, x = v.length; w < x; ++w)
                        (function (m) {
                            o[m] =
                                o[m] ||
                                    function () {
                                        o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                                    };
                        })(v[w]);
                    y = e.createElement(n);
                    y.async = !0;
                    y.src = 'https://content.d.compono.com/agent/static/' + apiKey + '/pendo.js';
                    z = e.getElementsByTagName(n)[0];
                    z.parentNode.insertBefore(y, z);
                })(window, document, 'script', 'pendo');
            })(config.token);
            pendo.initialize();
        },
        page: function () {
            return;
        },
        track: function (_a) {
            var payload = _a.payload, config = _a.config;
            pendo.track(payload.event, tslib_1.__assign({ userId: "".concat(config.stage, "-").concat(payload.userId || payload.anonymousId) }, payload.properties));
        },
        identify: function (_a) {
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var payload = _a.payload, config = _a.config;
            pendo.identify({
                visitor: {
                    id: "".concat(config.stage, "-").concat(payload.userId || payload.anonymousId),
                    source: (_b = payload.traits) === null || _b === void 0 ? void 0 : _b.source,
                    role: (_c = payload.traits) === null || _c === void 0 ? void 0 : _c.role,
                    location: '',
                },
                account: {
                    id: (_e = (_d = payload.traits) === null || _d === void 0 ? void 0 : _d.organisation) === null || _e === void 0 ? void 0 : _e.id,
                    name: (_g = (_f = payload.traits) === null || _f === void 0 ? void 0 : _f.organisation) === null || _g === void 0 ? void 0 : _g.name,
                    applications: (_j = (_h = payload.traits) === null || _h === void 0 ? void 0 : _h.organisation) === null || _j === void 0 ? void 0 : _j.applications,
                    jobBoards: (_l = (_k = payload.traits) === null || _k === void 0 ? void 0 : _k.organisation) === null || _l === void 0 ? void 0 : _l.jobBoards,
                },
            });
        },
        loaded: function () {
            return !!window.pendo;
        },
    };
};
exports.createPendo = createPendo;
